export default {
  sarchShow: true,
  searchMenuSpan: 6,
  height: 'auto',
  calcHeight: 'auto',
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',

  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,

  column: [
    {
      label: '商户退款单号',
      prop: 'mchRefundNo',
      rules: [
        {
          required: true,
          message: '请输入商户退款单号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付渠道',
      prop: 'payPlatform',
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 100,

      rules: [
        {
          required: true,
          message: '请输入支付渠道',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付场景',
      prop: 'payScene',
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 100,

      rules: [
        {
          required: false,
          message: '请输入支付场景',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款金额(元)',
      prop: 'refundFee',
      width: 120,
      rules: [
        {
          required: true,
          message: '请输入退款金额(元)',
          trigger: 'change',
        },
      ],
    },

    {
      label: '退款状态',
      prop: 'refundStatus',
      search: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=refundStatus',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      width: 100,
      searchSpan: 5,
      rules: [
        {
          required: true,
          message: '请输入退款状态',
          trigger: 'change',
        },
      ],
    },
    {
      label: '申请人',
      prop: 'refundApplyName',
      rules: [
        {
          required: true,
          message: '请输入申请人',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款申请时间',
      prop: 'refundApplyTime',
      searchLabelWidth: 100,
      search: true,
      type: 'datetime',
      searchRange: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      searchSpan: 8,

      rules: [
        {
          required: true,
          message: '请输入退款申请时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '失败原因',
      prop: 'remark1',
      rules: [
        {
          required: true,
          message: '请输入失败原因',
          trigger: 'change',
        },
      ],
    },
    {
      label: '交易金额',
      prop: 'refundFeeStart',
      search: true,
      hide: true,
      searchSpan: 4,
      searchPlaceholder: '交易金额',
      rules: [
        {
          required: true,
          message: '请输入订单金额(元)',
          trigger: 'change',
        },
      ],
    },
    {
      label: '至',
      prop: 'refundFeeEnd',
      search: true,
      hide: true,
      searchSpan: 4,
      searchLabelWidth: 30,
      searchPlaceholder: '交易金额',
      rules: [
        {
          required: true,
          message: '请输入订单金额(元)',
          trigger: 'change',
        },
      ],
    },
  ],
};
